import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from '@edx/frontend-platform/i18n';
import SettingsOption from '../SettingsOption';
import { ProblemTypeKeys } from '../../../../../../data/constants/problem';
import messages from '../messages';
import { hintsCardHooks, hintsRowHooks } from '../hooks';
import HintRow from './HintRow';
import Button from '../../../../../../sharedComponents/Button';

const HintsCard = ({
  hints,
  problemType,
  updateSettings,
  images,
  isLibrary,
  learningContextId,
}) => {
  const intl = useIntl();
  const { summary, handleAdd } = hintsCardHooks(hints, updateSettings);

  if (problemType === ProblemTypeKeys.ADVANCED) { return null; }

  return (
    <SettingsOption
      className="hints-card"
      title={intl.formatMessage(messages.hintSettingTitle)}
      summary={intl.formatMessage(summary.message, { ...summary.values })}
      none={!hints.length}
      hasExpandableTextArea
    >
      {hints.map((hint) => (
        <HintRow
          key={hint.id}
          id={hint.id}
          value={hint.value}
          {...{
            ...hintsRowHooks(hint.id, hints, updateSettings),
            images,
            isLibrary,
            learningContextId,
          }}
        />
      ))}
      <Button
        className="m-0 p-0 font-weight-bold"
        variant="add"
        onClick={handleAdd}
        size="sm"
      >
        <FormattedMessage {...messages.addHintButtonText} />
      </Button>
    </SettingsOption>
  );
};

HintsCard.propTypes = {
  hints: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  problemType: PropTypes.string.isRequired,
  updateSettings: PropTypes.func.isRequired,
  images: PropTypes.shape({}).isRequired,
  learningContextId: PropTypes.string.isRequired,
  isLibrary: PropTypes.bool.isRequired,
};

export default HintsCard;
